import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { from } from 'rxjs';
import { AppURL } from 'src/app/app.url';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-secret-key-otp',
  templateUrl: './secret-key-otp.component.html',
  styleUrls: ['./secret-key-otp.component.scss']
})
export class SecretKeyOtpComponent {

  constructor(private http: HttpClient,
    private alert: AlertService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.getOtpList();
  }

  visible: boolean = false;
  otpItems: any = []

  getOtpList() {
    this.http.get(`otp`).subscribe({
      next: (res: any) => {
        // console.log(res.data);
        this.otpItems = res.data
      }
    })
  }

  SystemName: string = ""
  ApiServiceName: string = ""
  ApiKey: string = ""
  ApiSecret: string = ""
  ApiUrl: string = ""

  addOtpKey() {
    let model = {
      SystemName: this.SystemName,
      ApiServiceName: this.ApiServiceName,
      ApiKey: this.ApiKey,
      ApiSecret: this.ApiSecret,
      ApiUrl: this.ApiUrl,
    }
    this.http.post(`otp`, model).subscribe({
      next: (res: any) => {
        this.getOtpList()
        this.resetItem()
        this.alert.notify(res.message, 'success')
      }
    })
  }

  deleteOtpKey(item: any) {
    this.alert.confirm('Confirm Delete ?').then(f => {
      if (f.isConfirmed) this.http.delete(`otp/${item.Id}`).subscribe({
        next: (res: any) => {
          this.getOtpList()
          this.alert.notify(res.message, 'success')
        },
        error: (err) => {
          this.alert.notify(err.error.message, 'warning')
        }
      })
    })
  }


  resetItem() {
    this.visible = false
    this.SystemName = ""
    this.ApiServiceName = ""
    this.ApiKey = ""
    this.ApiSecret = ""
    this.ApiUrl = ""
    this.otpTel = ""
    this.otpMessage = ""
    this.viewSendOtp = ""
  }


  bankSystem() {
    this.router.navigate(['/', AppURL.secretkey])
  }

  viewSendOtp: any;
  otpTel: string = ""
  otpMessage: string = ""
  viewOtp(item: any) {
    this.viewSendOtp = item;
  }

  sendOtp() {
    let model = {
      ClientId: this.viewSendOtp.ClientId,
      ClientSecret: this.viewSendOtp.ClientSecret,
      Tel: this.otpTel,
      Message: this.otpMessage
    }
    this.http.post(`otp/send-demo`, model).subscribe({
      next: (res: any) => {
        this.alert.notify(res.message, 'success');
      },
      error: (err: any) => {
        this.alert.notify(err.error.message, 'warning');
      }
    })
  }


}
